export default {
  REPORTS: `Rapports`,
  REPORT_LIST: `Liste des rapports`,
  EXPORT: `Exporter`,
  REQUESTED_REPORT: `Voir les rapports déjà générés`,
  REQUEST_REPORT_DESCRIPTION: `Consultez et exportez des rapports personnalisables. Sélectionnez le type de rapport et les filtres en fonction de vos besoins.`,
  REQUEST_NEW_REPORT: `Demander un rapport`,
  REQUEST_REPORT_CARD: {
    TITLE: `Demande de rapport`
  },
  SELECT_REPORT: `Sélectionner un rapport à générer`,
  EXCEL: `Excel`,
  CSV: `CSV`,
  EMPLOYEE_NUMBER: `Numéro d'employé`,
  FULL_NAME: `Nom`,
  DEPARTMENTS: `Départements`,
  DEPARTMENT: `Département`,
  POSITION: `Position`,
  START: `Début`,
  END: `Fin`,
  ATTRIBUTES: `Attributs`,
  SELECT_DATE_RANGE: `Veuillez sélectionner des dates`,
  SELECT_ONE_GROUPING: `Veuillez sélectionner au moins un type de groupe`,
  NO_REPORTS: `Il n'y a aucun rapport d'activé, veuillez demander à votre administrateur d'en activer ou cliquez ici si vous êtes l'administrateur afin d'être redirigé vers les paramètres pertinents.`,
  ATTENDANCE_REPORT: {
    TITLE: `Absences`,
    SUMMARY: `Permet de voir le nombre de requêtes d'absence soumises par employé, position et/ou projet.`,
    REPORT_NAME: `rapport_absence`,
    GROUP_BY_USER: `Grouper par utilisateur`,
    GROUP_BY_POSITION: `Grouper par position`,
    GROUP_BY_PROJECT: `Grouper par projet`,
    DESCRIPTION: `Description`,
    NB_REQUEST: `Nombre de requêtes d'absence`,
    NO_PROJECT: `Aucun projet`,
    NO_POSITION: `Aucune position`,
    NO_USER: `Aucun utilisateur`,
    FULL_NAME: `Nom`,
    POSITION_NAME: `Position`,
    PROJECT_NAME: `Projet`
  },
  USER_ATTRIBUTES_REPORT: {
    TITLE: `Attributs`,
    SUMMARY: `Permet de visualiser les attributs des utilisateurs et de les exporter.`,
    REPORT_NAME: `rapport_attributs`,
    NAME: `Nom`,
    ATTRIBUTES: `Attributs`
  },
  EXPIRING_ATTRIBUTES_REPORT: {
    TITLE: `Attributs à expiration`,
    SUMMARY: `Permet d'exporter les attributs expirant dans une période de temps donnée.`,
    REPORT_NAME: `rapport_attributs_à_expiration_{{rangeStart}}-{{rangeEnd}}`,
    NAME: `Name`,
    ATTRIBUTE: `Attribut`,
    EXPIRATIONDATE: `Date d'expiration`,
    REMINDERS: `Rappels`,
    RANGE: {
      LABEL: `Intervalle de temps`,
      DESCRIPTION: ``
    }
  },
  PAY_REPORT_CONFIRMATION_MODAL: {
    TITLE: `Confirmation de l'exportation`,
    SUMMARY: `Êtes vous sûr de vouloir exporter le rapport avec ces paramètres?`
  },
  CONTACT_ACCEPTATION_REFUSAL_REPORT: {
    TITLE: `Acceptation et refus dans les listes de contacts`,
    SUMMARY: `Permet d'observer et d'exporter les acceptations et les refus de quarts de travail dans les listes de contacts.`,
    REPORT_NAME: `rapport_de_liste_de_contacts`,
    ATTRIBUTES: `Attributs`,
    ACCEPTATION_REFUSAL: `Accepté/Refusé`,
    ACCEPTATION: `<0>Accepté :</0> <1>{{count}}</1>`,
    ACCEPTATION_other: `<0>Acceptés :</0> <1>{{count}}</1>`,
    REFUSAL: `<0>Refusé :</0> <1>{{count}}</1>`,
    REFUSAL_other: `<0>Refusés :</0> <1>{{count}}</1>`,
    ACCEPTED: `Accepté`,
    REFUSED: `Refusé`,
    DEPARTMENTS: `Départements`,
    ACCEPTED_DATES: `Dates d'acceptation`,
    REFUSED_DATES: `Dates de refus`
  },
  DAILY_SUMMARY_REPORT: {
    TITLE: `Journalier sommaire`,
    SUMMARY: `Permet de voir et d'exporter des statistiques d'absences et du nombre de quarts de travail durant une période choisie.`,
    REPORT_NAME: `rapport_journalier_sommaire`,
    DATE: `Date`,
    POSITION: `Position`,
    DEPARTMENTS: `Départements`,
    NUMBER_ABSENT: `Absences`,
    NUMBER_EARLY_OUT: `Départ hâtif`,
    NUMBER_LATE: `Retard`,
    NUMBER_VARIABLE_END_TIME: `Heure de fin variable`,
    NUMBER_OVERTIME_SHIFT: `Temps supplémentaire`,
    NUMBER_REPLACEMENTS: `Remplacements`,
    NUMBER_SHIFTS: `Quarts`,
    NUMBER_UNASSIGNED_SHIFTS: `Quarts non-assignés`,
    TOTAL_HOURS: `Nombre d'heure total`,
    GROUP_BY_POSITIONS: `Grouper par position`,
    REMOVE_ROWS_WITHOUT_DATA: `Retirer les rangées sans données statistiques`
  },
  SCHEDULE_ANALYSIS_REPORT: {
    TITLE: `Analyse d'horaire`,
    SUMMARY: `Permet d'analyser le nombre de quarts, d'heures planifiées et payées, ainsi que le coût d'horaire.`,
    REPORT_NAME: `rapport_analyse_horaire_{{rangeStart}}-{{rangeEnd}}`,
    GROUPEMPLOYEE: `Grouper par utilisateur`,
    GROUPPOSITION: `Grouper par position`,
    GROUPDEPARTMENT: `Grouper par departement`,
    GROUPPROJECT: `Grouper par projet`,
    GROUPTEAM: `Grouper par équipe`,
    GROUPTIME: `Grouper par heure de début`,
    GROUPDATE: `Grouper par date de début`,
    NUMBER_OF_SHIFTS: `Nombre de quarts`,
    PLANNED_HOURS: `Heures planifiées`,
    PAID_HOURS: `Heures payées`,
    PLANNED_COST: `Coût planifié`,
    PAID_COST: `Coût payé`,
    PROJECT: `Projet`,
    TEAM: `Équipe`,
    SHIFT_DATE: `Date de début`,
    SHIFT_TIME: `Heure de début`,
    TOTALS: `Totaux`,
    TOTAL: `Total`,
    PAID: `Payé`,
    PLANNED: `Planifié`
  },
  PAY_EXPORT_NETHRIS_REPORT: {
    TITLE: `Paie (EmployeurD/Nethris)`,
    SUMMARY: ``,
    AMOUNT: `Quantité`,
    WEEK: `Sem.`,
    RANGE: `Dates à exporter`,
    PERIOD_END: `Date de fin de la période courante de paie`,
    PERIOD: `Numéro de semaine`,
    COMPANY: `Compagnie`,
    EMPLOYEEID: `Matricule`,
    FIRSTNAME: `prénom`,
    LASTNAME: `Nom`,
    EMPLOYEENAME: `Nom de l'employé`,
    STATEMENTNUMBER: `No relevé`,
    DIV: `Div.`,
    SERV: `Serv.`,
    DEPT: `Dépt.`,
    SDEPT: `S.-dépt.`,
    PERIODENDDATE: `Période`,
    WORKIDS1: `No de travail -S1`,
    WORKIDS2: `No de travail -S2`,
    WORKIDS: `No de travail -S2`,
    REMOVE_CARD_WITH_MISSING_INFO: `Retirer les cartes de temps qui ont des équivalences manquantes`,
    POSITIONCODES_DETAIL: `<0>co:</0> {{ companyId }} <0>div:</0> {{ division }} <0>dep:</0> {{ department }} <0>sdep:</0> {{ subDepartment }} <0>serv:</0> {{ service }} <0>taux:</0>{{hourlyRate}}`
  },
  PAY_EXPORT_APOGEE_REPORT: {
    TITLE: `Paie (Apogée)`,
    SUMMARY: ``,
    RANGE: {
      LABEL: `Dates à exporter`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  PAY_EXPORT_GENERIC_REPORT: {
    TITLE: `Paie (Générique)`,
    SUMMARY: ``,
    SHEET_NAME: `Paie`,
    REPORT_NAME_ALL: `rapport_de_paies_({{rangeStart}}-{{rangeEnd}})`,
    REPORT_NAME_REGULAR: `rapport_de_paies_temps_régulier ({{rangeStart}} - {{rangeEnd}})`,
    REPORT_NAME_OVERTIME: `rapport_de_paies_temps_supplémentaire ({{rangeStart}} - {{rangeEnd}})`,
    REPORT_NAME_OTHER: `rapport_de_paies_autre ({{rangeStart}} - {{rangeEnd}})`,
    REPORT_NAME_TIMEOFF_AND_ATTENDANCE: `rapport_de_paies_congés_et_absences_({{rangeStart}}-{{rangeEnd}})`,
    RANGE: { LABEL: `Dates à exporter`, DESCRIPTION: `` },
    POSITION: `Position`,
    PROJECT: `Projet`,
    DEPARTMENT: `Département`,
    INFORMATION: `Information`,
    SHIFT: `{{count}} quart`,
    SHIFT_other: `{{count}} quarts`,
    ERROR: `{{count}} Erreur de carte de temps`,
    ERROR_other: `{{count}} Erreurs de carte de temps`,
    TRANSFER: `{{count}} transfert`,
    TRANSFER_other: `{{count}} transferts`,
    NEED_ACTION: `{{count}} carte de temps nécessite une action, allez dans l'interface des cartes de temps pour approuver ces cartes.`,
    NEED_ACTION_other: `{{count}} cartes de temps qui nécessitent une action!`,
    NO_SHIFT: `{{count}} carte de temps avec quart manquant dans ce rapport.`,
    NO_SHIFT_other: `{{count}} cartes de temps avec quart manquants dans ce rapport.`,
    NO_SHIFT_DESC: `Les cartes de temps sans quart de travail associé ne peuvent pas être inclus dans le rapport de paie. Pour résoudre ce problème, accédez à la page des cartes de temps et ajoutez les quarts de travail manquants.`,
    USER: `Employé`,
    EMPLOYEENUMBER: `Numéro d'employé`,
    EARNINGCODE: `Code de gain`,
    AMOUNT: `Montant`,
    EARNINGCODE_AMOUNT: `Code de gain & Montant`,
    EMPLOYEEPAY: `Salaire`,
    REGULAR_PAY: `Régulier: {{ regular }}`,
    OVERTIME_PAY: `Temps supplémentaire: {{ overtime }}`,
    REQUEST_TYPE: `Raison ou type de congé`,
    ALL_FIELDS: `Exporter le rapport complet`,
    BY_POSITION_PROJECT: `Exporter le rapport groupé par position et projet`,
    BY_EARNING_CODE: `Exporter le rapport groupé par code de gain`,
    EARNING_CODES: `Code de gain`,
    ALL_DATA: `Toutes les données`,
    REGULAR_TIME: `Temps régulier seulement`,
    OVERTIME: `Temps supplémentaire seulement`,
    OTHER: `Autres codes de gain`,
    PROJECT_TAGS: `Étiquettes de projet`,
    DATE: `Date`
  },
  TIME_OFF_AND_ATTENDANCE_REPORT: {
    TITLE: `Paie pour congés et absences`,
    SUMMARY: ``
  },
  PROJECT_OWNER_WORKLOAD_REPORT: {
    TITLE: `Charge de travail des responsables de projet`,
    SUMMARY: `Permet d'afficher tous les projets, leurs responsables et leurs besoins en personnel aux dates sélectionnées.`,
    REPORT_NAME: `rapport_de_charge_de_travail_projets`,
    PROJECT_OWNERS: `Responsables de projets`,
    PROJECT_NAME: `Projet`
  },
  PROJECT_USER_STATUS_REPORT: {
    TITLE: `Statut des utilisateurs assignés à un projet`,
    SUMMARY: `Permet de voir le statut des employés concernant un projet auquel ils sont assignés.`,
    REPORT_NAME: `rapport_de_status_des_utilisateurs_projets`,
    DEPARTMENTS: `Départements`,
    OCCUPATIONS: `Assignations`,
    ATTRIBUTES: `Attributs`,
    PROJECT_LOCKED: `Verrouillé`,
    PROJECT_BLOCKED: `Bloqué`,
    PROJECT_PREFERRED: `Préféré`,
    PRIMARY_OCCUPATIONS: `Assignation primaire`,
    SECONDARY_OCCUPATIONS: `Assignation secondaire`,
    RESTRICTIONS: `Restrictions`,
    SKILLS: `Qualifications`,
    REQUIREMENTS: `Exigences`
  },
  SCHEDULE_CAPACITY_DEBUG_REPORT: {
    TITLE: `Déboggage de la capacité de travail`,
    SUMMARY: `Permet d'inspecter une position et une date spécifique pour la capacité de travail, ainsi que d'exporter la liste des utilisateurs comptabilisés.`,
    REPORT_NAME: `rapport_de_deboggage_capacité_travail`,
    OCCUPATIONS: `Assignations`,
    DATE: `Date`,
    IS_ELIGIBLE: `Est éligible`,
    UNAVAILABLE_ALL_DAY: `Non disponible`,
    ON_TIME_OFF: `En congé`,
    ON_LEAVE: `Absent`,
    TOTAL_PRIMARY: `<0>Total primaire :</0> {{value}}`,
    TOTAL_SECONDARY: `<0>Total secondaire :</0> {{value}}`,
    TOTAL: `<0>Total :</0> {{num}} / {{total}}`,
    PRIMARY_OCCUPATIONS: `Assignation primaire`,
    SECONDARY_OCCUPATIONS: `Assignation secondaire`
  },
  VACATION_RAW_REPORT: {
    TITLE: `Rapport de congés brut`,
    SUMMARY: `Permet d'exporter les données bruts des congés.`
  },
  ATTENDANCE_RAW_REPORT: {
    TITLE: `Rapport d'absences brut`,
    SUMMARY: `Permet d'exporter les données bruts des absences.`
  },
  SCHEDULE_EXPORT_REPORT: {
    TITLE: `Exportation de l'horaire`,
    SUMMARY: `Permet de visualiser tous les quarts de travail s'étant déroulés lors d'une période spécifique.`,
    REPORT_NAME: `rapport_horaire`,
    EMPLOYEE_NUMBER: `Numéro d'employé`,
    START: `Début`,
    STARTDATE: `Date de début`,
    END: `Fin`,
    ENDDATE: `Date de fin`,
    EMPLOYEENUMBER: `Numéro d'employé`,
    FIRSTNAME: `Prénom`,
    LASTNAME: `Nom`,
    PRIMARYOCCUPATION: `Occupation primaire`,
    POSITIONCODE: `Code de position`,
    POSITIONNAME: `Position`,
    COMMENT: `Commentaire`,
    STATUS: `Statut`,
    ARRIVALTIME: `Arrivée`,
    DEPARTURETIME: `Départ`,
    PROJECTNAME: `Projet`,
    PROJECTCODE: `Code du projet`,
    PROJECTOWNERS: `Responsables du projet`,
    LOCKEDTOPROJECT: `Vérouillé sur ces projets`,
    BLOCKEDFROMPROJECT: `Bloqué de ces projets`,
    PREFERREDONPROJECT: `Préféré sur ces projets`,
    TEAMNAME: `Équipe`,
    CLIENTTAGS: `Étiquettes de client`,
    IS_VARIABLE_END_TIME: `Temps de fin variable`,
    ISIRREPLACEABLE: `Ne doit pas être remplacé`,
    NEEDSREPLACEMENT: `Quart à combler`,
    COVEREDOTHERUNIT: `Couvert par une autre unité`,
    ISOVERTIME: `Temps supplémentaire`,
    ISONCALL: `Sur appel`,
    NOEMPLOYEEAVAILABLE: `Aucun employé disponible`,
    HASSPECIFICREQUIREMENTS: `A des requis spécifiques`,
    LOCATIONTAGS: `Étiquettes d'emplacement`,
    REGIONALTAGS: `Étiquettes de région`,
    RESOURCETAGS: `Étiquettes de ressource`,
    CUSTOMTAGS: 'Étiquettes personnalisée',
    USERDEPARTMENTS: `Département de l'utilisateur`,
    SHIFTDEPARTMENTS: `Département du quart de travail`,
    POSITION_CODE: `Code de position`,
    TEMPLATE: `Nom du modèle d'horaire`,
    TEMPLATEID: `Id du modèle d'horaire`,
    SHIFTID: `Id du quart de travail`
  },
  VACATION_REPORT: {
    TITLE: `Congés`,
    SUMMARY: `Permet de voir le nombre de congés approuvés durant une période choisie.`,
    REPORT_NAME: `rapport_de_congé_{{rangeStart}}-{{rangeEnd}}`,
    TYPE: `Type`
  },
  AVAILABILITY_REPORT: {
    TITLE: `Disponibilités`,
    SUMMARY: `Permet de générer un récapitulatif des disponibilités de chaque employé, ainsi que ses préférences de travail pour une période choisie.`,
    REPORT_NAME: `rapport_de_disponibilités_{{rangeStart}}-{{rangeEnd}}`,
    AVAILABLITIES: `Disponibilités`,
    INFORMATION: `Information`,
    ATTRIBUTES: `Attributs : `,
    HIRING_DATA: `Données d'embauches : `
  },
  REQUESTS: {
    TITLE: `Rapports demandés`,
    SUMMARY: `Permet de  voir tous les rapports demandés et leur statut.`,
    TYPE: `Type`,
    STATUS: `Statut`,
    REQUESTEDAT: `Demandé le`,
    FILTERS: `Filtres`,
    DATES: `Dates`,
    SCHEDULE_ANALYSIS_REPORT: `Analyse d'horaire`,
    PENDING: 'en attente',
    PROCESSING: 'en traitement',
    READY: 'prêt',
    FAILED: 'échec',
    DELETE_BUTTON: {
      TITLE: 'Supprimer la demande de rapport',
      SUMMARY: 'Êtes-vous certain de vouloir supprimer cette demande de rapport ?',
      PRIMARY_ACTION: `Supprimer la demande de rapport`
    },
    EMAIL_NOTIFICATION: `Notez que si le rapport prend plus d'une minute à se générer, un courriel vous sera envoyé une fois qu'il sera prêt.`
  },
  USER_CONTACT_REPORT: {
    TITLE: `Contact par utilisateur`,
    SUMMARY: `Permet de voir le nombre de contacts total effectués par utilisateur durant une période choisie.`,
    REPORT_NAME: `rapport_de_contact_par_utilisateur`,
    CALL_LENGTH: `<0>Durée des appels :</0> {{totalCallLength}}`,
    CONTACT: `<0>Contacté :</0> {{count}}`,
    CONTACT_other: `<0>Contactés :</0> {{count}}`,
    INFORMATION: `Information`,
    NB_BY_PHONE: `Nombre de contacts par téléphone`,
    NB_BY_PHONE_DESC: `Permet de voir le nombre de contacts total effectués par utilisateur durant une période choisie (ex.: si un utilisateur possède deux numéros de téléphone et que le système l'appelle sur le premier puis envoie un message texte sur le deuxième, cela constitue deux contacts).`,
    NB_BY_EMAILS: `Nombre de contacts par courriel`,
    NB_BY_EMAILS_DESC: `Permet de voir le nombre de contacts total effectués via courriel et par utilisateur durant une période choisie.`,
    BY_CALL_LENGTH: `Durée de l'appel`,
    BY_CALL_LENGTH_DESC: `Permet de calculer le temps total qu'un utilisateur a passé au téléphone durant une période choisie (incluant le temps passé à laisser un message vocal)`,
    ATTRIBUTES: `Attributs`,
    DEPARTMENTS: `Départements`
  },
  CONTACT_AMOUNT_REPORT: {
    TITLE: `Contact par utilisateur`,
    SUMMARY: `Permet de voir le nombre de contacts total effectués par utilisateur durant une période choisie.`
  },
  CONTACT_CALL_LENGTH_REPORT: {
    TITLE: `Contact par utilisateur (Contact par téléphone)`,
    SUMMARY: `Permet de calculer le temps total qu'un utilisateur a passé au téléphone durant une période choisie (incluant le temps passé à laisser un message vocal)`
  },
  CONTACT_EMAIL_AMOUNT_REPORT: {
    TITLE: `Contact par utilisateur (Contact par courriel)`,
    SUMMARY: `Permet de voir le nombre de contacts total effectués via courriel et par utilisateur durant une période choisie.`
  },
  SKYLINE_REPORT: {
    TITLE: `Planification des projets à l'horaire`,
    SUMMARY: `Permet de générer un sommaire de tous les quarts de travail par projet, position et heure de début/fin durant une période choisie.`,
    REPORT_NAME: `rapport_de_planification_de_projets_{{rangeStart}}-{{rangeEnd}}`,
    NAME: `Nom`,
    CODE: `Code`,
    PROJECT_STATUS: `Statut`,
    DEPARTMENT: `Département`,
    POSITION: `Position`,
    CLIENTS: `Clients`,
    LOCATION: `Emplacement`,
    START_TIME: `Heure de début`,
    LENGTH: `Durée`,
    PROJECT_OWNERS: `Responsable de projets`,
    DATES: `Dates`,
    GROUP_DATES: `Grouper les dates en une colonne`
  },
  QUESTIONNAIRE_RESPONSES: {
    TITLE: `Réponses aux questionnaires`,
    SUMMARY: `Permet d'exporter les réponses aux questionnaires.`,
    CREATED_AT: `Rempli à`,
    NOT_ALLOWED_TO_PUNCH: `N'a pas pu poinçonner`,
    ERROR_TRIGGERED: `A été averti`,
    ANSWERS: `Réponses`,
    EXPLANATION: `Explication`,
    REPORT_NAME: 'export_questionnaire_{{rangeStart}}-{{rangeEnd}}',
    PUNCHQUESTIONNAIRE: `Questionnaire de poinçon`,
    DAILYQUESTIONNAIRE: `Questionnaire journalier`
  },
  UNSCHEDULED_USERS_REPORT: {
    TITLE: `Employés non assignés à l'horaire`,
    SUMMARY: `Permet d'exporter une liste d'employés qui ne sont pas assignés à l'horaire sur une plage définie.`,
    REPORT_NAME: `rapport_employes_non_assignes_{{ range }}`,
    FILTERONTIMEOFF: {
      LABEL: `Vérifier les congés`,
      DESCRIPTION: `Si actif, les employés en congé seront également filtrés de la liste.`
    }
  }
}
